import { createSlice } from "@reduxjs/toolkit";

// Load saved orders from localStorage if available
const savedOrders = JSON.parse(localStorage.getItem("orders")) || [];

const orderSlice = createSlice({
  name: "orders",
  initialState: {
    list: savedOrders, // initialize from localStorage
  },
  reducers: {
    addOrder: (state, action) => {
      state.list.unshift(action.payload);
      // Save updated orders to localStorage
      localStorage.setItem("orders", JSON.stringify(state.list));
    },
    setOrders: (state, action) => {
      state.list = action.payload;
      localStorage.setItem("orders", JSON.stringify(state.list));
    },
    clearOrders: (state) => {
      state.list = [];
      localStorage.removeItem("orders");
    },
  },
});

export const { addOrder, setOrders, clearOrders } = orderSlice.actions;
export default orderSlice.reducer;
